export const SOFTLINE_API_REMOTE_CONFIG = '/v1/app/config';
